// ============================================================
// COMMON BLUPRINT BUILDERS
//
// Shared helper functions used by every BluPrint hydrator.
//
// Hydrators translate database objects into BluPrint objects.
// These helpers keep every hydrator consistent.
// ============================================================

/**
 * Safely unwrap a lookup-table relationship.
 *
 * Returns null instead of undefined so the UI can simply use:
 *
 *    item.priority?.name
 *
 * without worrying about missing relationships.
 */
export function relation(value) {
  return value ?? null
}

/**
 * Normalize display text.
 *
 * Always returns a string.
 */
export function summary(value) {
  return value?.trim?.() ?? ''
}

/**
 * Normalize boolean values.
 *
 * Makes intent obvious inside hydrators.
 */
export function flag(value) {
  return value === true
}

/**
 * Indicates whether a relationship exists.
 *
 * Reads much nicer than !!relationship.
 */
export function exists(value) {
  return value != null
}

/**
 * Safely return an array.
 *
 * Prevents "cannot map undefined".
 */
export function collection(value) {
  return Array.isArray(value) ? value : []
}